import WRAP from "WRAP-JS";
import * as FPEUtils from "../../../utils/FPEUtils";

/* eslint-disable */
WRAP.Renderer.GeoJSONExt = function() {
  WRAP.Renderer.call(this);

  var superDrawFeature = this.drawFeature;

  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

    this.drawFlg = false;
    var current_zoom = -1;
    if ( context && context.tiles.length )
      current_zoom = context.zoom;

    var data_conf = data.configuration('data');
    if ( data_conf.update_interval && data_conf.auto_update === false )
      return;

    //AMeDASの矢羽を表示するとPointInfoとGeoJSONのrenderが無限ループするためdynamicはfalse固定に変更
    //https://wni.backlog.jp/view/WRAP-855 の機能をomitすることになるが、LinksではMercator表示だけなので問題はない
    // var dynamic = this.requireDynamicDraw(conf);
    var dynamic = false;
    if ( !dynamic ) {
      var tiled = data_conf.Grid && data_conf.Grid.MaxZoom;
      if ( !tiled ) {
        if ( !conf.Attributes.min_zoom ) {
          if ( this.content_revision == revision.content
            &&  this.conf_revision == revision.conf
            &&  this.style_revision == revision.style
            &&  this.data_revision == revision.data )
            return;
        }
        else {
          if ( this.last_zoom == current_zoom
            &&  this.content_revision == revision.content
            &&  this.conf_revision == revision.conf
            &&  this.style_revision == revision.style
            &&  this.data_revision == revision.data )
            return;
        }
      }
      else {
        if ( this.content_revision == revision.content
          &&  this.context_revision == revision.context
          &&  this.conf_revision == revision.conf
          &&  this.style_revision == revision.style
          &&  this.data_revision == revision.data )
          return;
      }
    }
    layer.setStatus({status:"invalid"});

    var tiles = null;
    if ( data_conf.retain ) {
      var geo = data.retained.data;
      if ( geo ) {
        tiles = Array.isArray(geo) ? geo : [geo];
      }
      else if ( data.status.data && data.status.data != 'completed' ) {
        layer.setStatus({status:"error", reason:data.status.data});
      }
    }
    else {
      if (current_zoom < conf.Attributes.min_zoom) {
        layer.clear();
        this.drawFlg = true;
        return;
      }
      var bounds = [];
      for ( var i = 0 ; i < context.tiles.length ; i++ ) {
        var tb = context.tiles[i].bounds;
        var b = {
          north:tb.north/60,
          south:tb.south/60,
          west:tb.west/60,
          east:tb.east/60
        }
        bounds.push(b)
      }
      var z = context.zoom;
      var dpt = 360/Math.pow(2,z);
      var sampling = "dpt "+dpt;
      tiles = this.getGeoObject(data, 'data', bounds, content, sampling, layer);
    }
    if ( !tiles )
      return;

    var features = [];
    for ( var i = 0 ; i < tiles.length ; i++ ) {
      var tile = tiles[i];
      if ( !tile ) continue;
      var fc = tile.features;
      if ( fc ) {
        for ( var j = 0 ; j < fc.length ; j++ )
          features.push(fc[j]);
      }
      else if ( tiles[i].type == "Feature" ) {
        features.push(tiles[i]);
      }
    }

    layer.clear();
    this.drawFlg = true;

    if ( !conf.Attributes.min_zoom || current_zoom >= conf.Attributes.min_zoom ) {
      var style_name = style||"default";
      var render_types = conf.Attributes.features;

      if ( conf.Attributes.sort ) this.sortItem(features, conf.Attributes.sort);

      for ( var i = 0 ; i < features.length ; i++ ) {
        var item = features[i];
        var geometry = item.geometry;
        if ( !geometry )
          continue;
        var prop = item.properties;
        if ( prop && prop.display_flag === false )
          continue;
        if ( conf.Attributes.filter && !conf.Attributes.filter(item, i, features) )
          continue;
        var ts = this.selectStyle(render_types[geometry.type] ? render_types[geometry.type] : render_types, prop, style_name);
        if ( !ts )
          continue;
        this.drawFeature(layer, item, prop, ts);
      }
    }

    this.content_revision = revision.content;
    this.context_revision = revision.context;
    this.conf_revision = revision.conf;
    this.style_revision = revision.style;
    this.data_revision = revision.data;
    this.last_zoom = current_zoom;

    if ( layer.getStatus().status != 'error' )
      layer.setStatus({status:"valid"});
    WRAP.Geo.invalidate();
  }

  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  function each(t, arrayed, cb) {
    if (arrayed)
      for ( var i = 0 ; i < t.length ; i++ )
        t[i]&&cb(t[i]);
    else
      t&&cb(t);
  }

  this.drawFeature = function(layer, geo, prop, style, data) {
    var geometry = geo.geometry;
    var properties = geo.properties;
    if ( !geometry )
        return;

    // Pointのpoint_colorをproperty指定できるように拡張
    const _style = FPEUtils.deepCopy(style);
    [].concat(_style).forEach(s => {
      if (geometry.type === "Point" && typeof s.point_color === "object" ) {
        s.point_color = this.resolve(prop, s.point_color);
      }
    });

    if (geometry.type == "Point" && properties.subType == "Circle" && properties.radius > 0) {
      each(geometry.coordinates, false,
        function (point) {
          each(_style, Array.isArray(_style),
            function (s) {
              if (s.type == "circle") {
                var feature = new WRAP.Geo.Feature.GeoArc({
                  point: point,
                  radius: properties.radius,
                  start: -180,
                  end: 180,
                  strokeStyle: s.line_color,
                  lineWidth: s.line_width,
                  fillStyle: s.fill_color,
                  lineDash: s.line_dash,
                });
                addFeature(layer, feature, geo, data ? prop : undefined);
              } else {
                superDrawFeature(layer, geo, prop, _style, data);
              }
            });
        });
    } else {
      superDrawFeature(layer, geo, prop, _style, data);
    }
  }
};
/* eslint-enable */
